import { UserManagerSettings } from 'oidc-client';
import { AzureActiveDirectoryConfig } from '../config/config';
import { loggedOutUrl, logInRedirectUrl, silentTokenRefreshUrl } from './authenticationUrls';

export const getUserManagerSettings = ({
  azureActiveDirectoryConfig,
}: {
  azureActiveDirectoryConfig: AzureActiveDirectoryConfig;
}): UserManagerSettings => ({
  authority: azureActiveDirectoryConfig.authority,
  client_id: azureActiveDirectoryConfig.clientId,
  redirect_uri: `${window.location.origin}/${logInRedirectUrl}`,
  response_type: 'token id_token',
  scope: `openid profile api://${azureActiveDirectoryConfig.clientId}/API`,
  post_logout_redirect_uri: `${window.location.origin}/${loggedOutUrl}`,
  silent_redirect_uri: `${window.location.origin}/${silentTokenRefreshUrl}`,
  response_mode: 'fragment',
  loadUserInfo: false,
});
